import type { BackgroundTask } from '#/utils/asyncBackendTask/asyncBackendTaskTypes';
import { waitTaskCompleted } from '#/utils/asyncBackendTask/waitTaskCompleted';
import { postJson } from '#/utils/http/postJson';

import type { ApiBillingAddress } from './types/ApiBillingAddress';

export type UTMParams = {
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmTerm?: string;
  utmContent?: string;
};
export type CreditCard = {
  stripeTokenId: string;
  methodId: string;
};
export type Donation = ApiBillingAddress &
  UTMParams & {
    sfCampaignId?: string;
    amount: string;
    otherAmount: string;
    firstName: string;
    gift: boolean;
    lastName: string;
    email: string;
    phone: string;
    sendEmails: true;
    note: string;
  };
export type DonationPayload = Donation & CreditCard;

type DonationResult = {
  success: boolean;
  invoiceIds?: string[];
  errorHuman?: string;
  error?: {
    msg: string;
    stripeCode: string;
  };
};

async function createDonation(
  donation: Donation,
  token: string,
): Promise<BackgroundTask<DonationResult>> {
  return postJson<{ task: BackgroundTask<DonationResult> }>(
    `/data/website/donate`,
    {
      ...donation,
      token,
    },
  ).then(({ task }) => task);
}

async function handleStripeBackgroundTask(
  task: BackgroundTask<DonationResult>,
) {
  return waitTaskCompleted(task);
}

export async function makeDonation(
  values: DonationPayload,
): Promise<DonationResult> {
  const { stripeTokenId, ...donation } = values;
  return createDonation(donation, stripeTokenId)
    .then((task) => handleStripeBackgroundTask(task))
    .then((result) => result);
}
